export function mounted() {
  this.resetForm()
  this.checkStep()
}
